// extracted by mini-css-extract-plugin
export default {"title":"PaymentSchemeDetails_title__TMDZM","total":"PaymentSchemeDetails_total__WY+rT","pay":"PaymentSchemeDetails_pay__Dlt8o","edit":"PaymentSchemeDetails_edit__HFhyN"};